import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { FichaDepositoBancoEdit } from "./edit";
const EditModal = FichaDepositoBancoEdit;
type Entity = models.FichaDepositoBancoDTO;
export interface Props {
    value: Entity[];
    onChange: (value: Entity[]) => PromiseLike<void>;
    readonly?: boolean;
}

/**Obtiene las columnas del grid */
const columnasFijas: kea.Grid2Column<Entity>[] = [
    { title: "Banco", cell: x => ({ data: x.NombreBanco }) },
    { title: "Monto", cell: x => ({ data: kea.formatCurrency(x.Monto) }) },
    { title: "Folio deposito", cell: x => ({ data: x.FolioFichaDeposito }) },
    { title: "Observaciones", cell: x => ({ data: x.Observaciones }) },
    { title: "No. Cuenta banco", cell: x => ({ data: x.NoCuentaBanco }) },
];


export interface BotonesDeps {
    onBorrar: (item: Entity) => void;
    onEdit: (item: Entity) => void;
}

function botones(deps: BotonesDeps, soloLectura: boolean): kea.Grid2Column<Entity, undefined> {
    return kea.columnaBotones<Entity>([
        {
            tooltip: "Modificar deposito",
            style: "primary",
            iconClass: fa("pencil"),
            disabled: x => soloLectura,
            onClick: deps.onEdit
        }, {
            tooltip: "Eliminar deposito",
            style: "danger",
            iconClass: fa("trash-o"),
            disabled: x => soloLectura,
            onClick: deps.onBorrar
        }
    ]);
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps, soloLectura: boolean): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps, soloLectura), ...columnasFijas];
}


/**
* Listado de FichaDepositoBanco
*/
class FichaDepositoBancoListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();


    private setDescripciones = async (x: models.FichaDepositoBanco): Promise<Entity> => {
        var banco = await resources.Banco.getMemo(x.IdBanco);
        return { ...x, NombreBanco: banco.Nombre, NoCuentaBanco: banco.NoCuenta };
    }

    private handleOnAgregar = async () => {
        const result = await this.modals.showModal(EditModal, undefined, {} as Entity);
        if (result.result) {
            const newItem = await this.setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange([...oldList, newItem]);
        }
    }

    private handleOnEditar = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, undefined, item);
        if (result.result) {
            const newItem = await this.setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange(oldList.map(x => x == item ? newItem : x));
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.FolioFichaDeposito);
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    render() {
        const cols = columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar }, this.props.readonly!);
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h4>
                            <span>Fichas de deposito de banco</span>
                            <div className="pull-right">
                                <kea.AgregarButton onClick={this.handleOnAgregar} disabled={this.props.readonly} />
                            </div>
                        </h4>
                    </div>
                </div>

                <kea.Grid2 items={this.props.value} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const FichaDepositoBancoList = kea.mapProps(componentToRx(FichaDepositoBancoListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/depositobanco/edit/components/fichasdeposito/list.tsx